module.exports = __webpack_public_path__ + "media/svg-new/good 1-d18a16c6.svg";